import { toggleClass } from "./utils/classToggler";
export var makeNavController = function () {
    console.log("makeNavController");
    var s = {
        init: function () {
            s.initWindowScrollListener();
            s.initMobileMenu();
        },
        initWindowScrollListener: function () {
            var navbar = document.querySelector(".site-nav");
            window.addEventListener("scroll", function () {
                if (window.scrollY > 0) {
                    document.documentElement.classList.toggle('page-scrolled', window.scrollY > 0);
                    navbar === null || navbar === void 0 ? void 0 : navbar.classList.add("scrolled");
                }
                else {
                    navbar === null || navbar === void 0 ? void 0 : navbar.classList.remove("scrolled");
                }
            });
        },
        initMobileMenu: function () {
            // console.log('initMobileMenu');
            // console.log(this.getScrollY);
            var menuState = "closed";
            var nav = document.querySelector(".site-nav");
            var toggleBtn = document.querySelector(".mobile-menu-toggle");
            if (!nav || !toggleBtn) {
                console.error("nav or toggleBtn not found");
                return;
            }
            var toggleOpen = function () {
                console.log("toggleOpen");
                toggleClass(nav, "open");
                toggleClass(document.documentElement, "menu-open");
                var useEl = document.querySelector("button.mobile-menu-toggle use");
                switch (menuState) {
                    case "open":
                        menuState = "closed";
                        if (useEl)
                            useEl.setAttribute("xlink:href", "#base-icon-menu");
                        break;
                    case "closed":
                        menuState = "open";
                        if (useEl)
                            useEl.setAttribute("xlink:href", "#icon-x");
                        break;
                }
            };
            toggleBtn.addEventListener("click", toggleOpen);
        },
    };
    return s;
};
var NavController = makeNavController();
export default NavController;
